/* BMN Bundle PDP, fixed-price kit with a per-component size x quantity grid.
 *
 * The buyer distributes each kit component (e.g. 5 polos, 3 hoodies) across sizes
 * until every component is fully allocated. The price never drifts: it is the one
 * fixed bundle price. Add-to-cart adds a SINGLE bundle variant (quantity 1) and
 * carries the full size split, colour and logo choice as line-item properties.
 * The logo (upload now / supply later) always routes to the quote lead path
 * (HubSpot form + WhatsApp + info@), reusing the enriched-PDP lead pattern, so
 * there are no dead ends. Prices are ex VAT and rendered server-side via the
 * vat-money snippet, so the header VAT toggle handles inc/ex.
 */
(function () {
  'use strict';

  var COLOUR_MAP = {'black':'#1a1a1a','jet black':'#0d0d0d','white':'#ffffff','arctic white':'#ffffff','natural':'#efe7d6','ecru':'#efe7d6','navy':'#20294a','french navy':'#1b2440','oxford navy':'#1b2440','red':'#c0202a','classic red':'#c0202a','burgundy':'#6d1f2e','maroon':'#5e1a2b','royal':'#1f4fb0','royal blue':'#1f4fb0','sapphire':'#1e63a8','sapphire blue':'#1e63a8','sky':'#7fb9e6','sky blue':'#7fb9e6','light blue':'#a9cde8','turquoise':'#2bb6c4','teal':'#1f8a8a','bottle green':'#0f3b2e','bottle':'#0f3b2e','forest':'#16432c','kelly':'#1f8f48','kelly green':'#1f8f48','green':'#1f8f48','lime':'#9cc63b','olive':'#6b6a2f','khaki':'#7c734a','sage':'#9bae8e','charcoal':'#3a3a3a','dark grey':'#4a4a4a','graphite':'#4a4a4a','heather grey':'#9b9b9b','grey':'#9b9b9b','gray':'#9b9b9b','sport grey':'#a8a8a8','light grey':'#cfcfcf','solid grey':'#8f8f8f','silver':'#c8c8c8','ash':'#d7d7d2','stone':'#d8c9a3','purple':'#5b3a8a','plum':'#5e2a4d','fuchsia':'#c43d8a','pink':'#e58fb0','light pink':'#f1c4d4','rose':'#d98aa0','coral':'#f08a6d','yellow':'#f4d03f','gold':'#e3b341','orange':'#e8732a','hi-vis yellow':'#c4d101','hi vis yellow':'#c4d101','fluorescent yellow':'#c4d101','fluo yellow':'#c4d101','hi-vis orange':'#ec7225','hi vis orange':'#ec7225','fluorescent orange':'#ec7225','fluo orange':'#ec7225','brown':'#5a3d2b'};

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function Bundle(root) {
    this.root = root;
    this.variantId = parseInt(root.getAttribute('data-variant-id'), 10) || 0;
    this.title = root.getAttribute('data-product-title') || '';
    this.handle = root.getAttribute('data-product-handle') || '';
    this.whatsapp = root.getAttribute('data-whatsapp') || '';
    this.leadUrl = root.getAttribute('data-lead-url') || '';
    this.quoteEndpoint = root.getAttribute('data-quote-endpoint') || '';
    this.attachmentsLive = root.getAttribute('data-attachments-live') === '1';
    this.totalItems = parseInt(root.getAttribute('data-total-items'), 10) || 0;
    try { this.colourVariants = JSON.parse(root.getAttribute('data-colour-variants') || '{}'); } catch (e) { this.colourVariants = {}; }
    this.activeVariantId = this.variantId;
    this.logoFile = null;
    this.logoFileRaw = null;   // the File itself, posted with the cart
    this.position = null;
    this.colour = null;
    var kitEl = root.querySelector('.bmn-bundle__kit');
    try { this.kit = kitEl ? JSON.parse(kitEl.textContent) : {}; } catch (e) { this.kit = {}; }
    this._cache();
    this._applyColourSwatches();
    this._bind();
    var firstSw = this.swatches[0];
    if (firstSw) this._selectColour(firstSw);
    if (this.posOpts[0]) this._selectPosition(this.posOpts[0]);
    this._recompute();
  }

  Bundle.prototype._cache = function () {
    var r = this.root;
    this.comps = Array.prototype.slice.call(r.querySelectorAll('.bmn-bundle__comp'));
    this.swatches = Array.prototype.slice.call(r.querySelectorAll('.bmn-bundle__swatch'));
    this.colourLabel = r.querySelector('.bmn-bundle__colour-current');
    this.addBtn = r.querySelector('.bmn-bundle__add');
    this.mockupBtn = r.querySelector('.bmn-bundle__mockup');
    this.waBtn = r.querySelector('.bmn-bundle__whatsapp');
    this.msg = r.querySelector('.bmn-bundle__msg');
    this.allocTotal = r.querySelector('.bmn-bundle__alloc-total');
    this.allocFill = r.querySelector('.bmn-bundle__alloc-fill');
    this.posOpts = Array.prototype.slice.call(r.querySelectorAll('.bmn-bundle__pos-opt'));
    this.drop = r.querySelector('.bmn-bundle__drop');
    this.fileInput = r.querySelector('.bmn-bundle__file');
    this.picked = r.querySelector('.bmn-bundle__picked');
    this.fileLabel = r.querySelector('.bmn-bundle__file-label');
    this.filePreview = r.querySelector('.bmn-bundle__file-preview');
    this.fileMsg = r.querySelector('.bmn-bundle__file-msg');
    this.fileRemove = r.querySelector('.bmn-bundle__file-remove');
    this.laterInput = r.querySelector('.bmn-bundle__later-input');
    this.company = r.querySelector('.bmn-bundle__company');
    this.fileWa = r.querySelector('.bmn-bundle__file-wa');
    this.lead = r.querySelector('.bmn-bundle__lead');
  };

  Bundle.prototype._applyColourSwatches = function () {
    this.swatches.forEach(function (sw) {
      // The kit can supply an exact hex and a photo of the real garment; when it
      // does, that wins over the generic name-to-hex guess below.
      if (sw.getAttribute('data-image') || sw.getAttribute('data-hex')) return;
      var n = (sw.getAttribute('data-value') || '').toLowerCase().trim();
      var hex = COLOUR_MAP[n];
      if (!hex) { for (var k in COLOUR_MAP) { if (n.indexOf(k) !== -1) { hex = COLOUR_MAP[k]; break; } } }
      if (hex) { sw.style.background = hex; if (hex === '#ffffff') sw.style.boxShadow = 'inset 0 0 0 1px rgba(15,15,15,0.25)'; }
    });
  };

  Bundle.prototype._bind = function () {
    var self = this;
    this.swatches.forEach(function (sw) { sw.addEventListener('click', function () { self._selectColour(sw); }); });
    this.root.querySelectorAll('.bmn-bundle__qty').forEach(function (i) {
      i.addEventListener('input', function () { self._clamp(i); self._recompute(); self._clearMsg(); });
      i.addEventListener('change', function () { self._clamp(i); self._recompute(); });
    });
    this.root.querySelectorAll('.bmn-bundle__step').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('.bmn-bundle__qty');
        var d = parseInt(btn.getAttribute('data-step'), 10) || 0;
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + d);
        self._clamp(input); self._recompute(); self._clearMsg();
      });
    });
    this.posOpts.forEach(function (btn) { btn.addEventListener('click', function () { self._selectPosition(btn); }); });
    if (this.fileInput) this.fileInput.addEventListener('change', function () { self._readFile(self.fileInput.files[0]); });
    if (this.fileRemove) this.fileRemove.addEventListener('click', function (e) { e.preventDefault(); self._resetFile(); self._fileSay(''); });
    if (this.laterInput) this.laterInput.addEventListener('change', function () {
      if (self.laterInput.checked) { self._resetFile(); self._fileSay(''); }
    });
    if (this.drop) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        self.drop.addEventListener(ev, function (e) { e.preventDefault(); self.drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        self.drop.addEventListener(ev, function (e) { e.preventDefault(); self.drop.classList.remove('is-over'); });
      });
      self.drop.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (f) self._readFile(f);
      });
    }
    if (this.fileWa) this.fileWa.addEventListener('click', function () { self._whatsapp(); });
    if (this.addBtn) this.addBtn.addEventListener('click', function () { self._addToCart(); });
    if (this.mockupBtn) this.mockupBtn.addEventListener('click', function () { self._openLead('mockup'); });
    if (this.waBtn) this.waBtn.addEventListener('click', function () { self._whatsapp(); });
    if (this.lead) {
      var form = this.lead.querySelector('form');
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self._submitLead(); });
      var close = this.lead.querySelector('.bmn-bundle__lead-close');
      if (close) close.addEventListener('click', function () { self.lead.hidden = true; });
      this.lead.addEventListener('click', function (e) { if (e.target === self.lead) self.lead.hidden = true; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.lead.hidden) self.lead.hidden = true; });
      var wa = this.lead.querySelector('.bmn-bundle__lead-wa');
      if (wa) wa.addEventListener('click', function () { self._whatsapp(); });
    }
  };

  Bundle.prototype._selectPosition = function (btn) {
    this.posOpts.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
    btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
    this.position = btn.getAttribute('data-pos');
  };

  Bundle.prototype._clamp = function (i) { var v = parseInt(i.value, 10); if (isNaN(v) || v < 0) v = 0; i.value = v; i.classList.toggle('is-active', v > 0); };

  Bundle.prototype._selectColour = function (sw) {
    this.swatches.forEach(function (s) { s.classList.remove('is-selected'); s.setAttribute('aria-pressed', 'false'); });
    sw.classList.add('is-selected'); sw.setAttribute('aria-pressed', 'true');
    this.colour = sw.getAttribute('data-value');
    this.activeVariantId = this.colourVariants[this.colour] || this.variantId;
    if (this.colourLabel) this.colourLabel.textContent = sw.getAttribute('data-label') || this.colour;
  };

  // No radio to get wrong: a file attached means "upload", anything else means
  // "send it later", which is a perfectly normal way to order.
  Bundle.prototype._logoMode = function () {
    return this.logoFile ? 'upload' : 'later';
  };

  var MAX_ATTACH = 3.5 * 1024 * 1024;  // Vercel body limit is 4.5MB, leave headroom
  var MAX_BYTES = 20 * 1024 * 1024;    // a trade logo PDF is routinely over 4MB
  var OK_EXT = /\.(png|jpe?g|gif|webp|svg|pdf|ai|eps|psd|tiff?)$/i;
  var PREVIEWABLE = /\.(png|jpe?g|gif|webp|svg)$/i;

  Bundle.prototype._fileSay = function (t, ok) {
    if (!this.fileMsg) return;
    this.fileMsg.textContent = t || '';
    this.fileMsg.className = 'bmn-bundle__file-msg' + (ok ? ' is-ok' : '');
  };

  Bundle.prototype._resetFile = function () {
    this.logoFile = null;
    this.logoFileRaw = null;
    if (this.fileInput) this.fileInput.value = '';
    if (this.fileLabel) this.fileLabel.textContent = '';
    if (this.picked) this.picked.hidden = true;
    if (this.filePreview) { this.filePreview.hidden = true; this.filePreview.removeAttribute('src'); }
  };

  // Reads the chosen file, validates it, previews it and keeps the base64 so the
  // lead submit can actually carry the artwork instead of just its filename.
  Bundle.prototype._readFile = function (f) {
    var self = this;
    if (!f) { this._resetFile(); this._fileSay(''); return; }
    if (this.laterInput) this.laterInput.checked = false;
    if (!OK_EXT.test(f.name)) {
      this._resetFile();
      if (this.picked) this.picked.hidden = false;
      this._fileSay('We cannot read that file type. Send a PNG, JPG, SVG, PDF, AI, EPS or PSD, or WhatsApp it over and we will sort it.');
      return;
    }
    if (f.size > MAX_BYTES) {
      this._resetFile();
      if (this.picked) this.picked.hidden = false;
      this._fileSay('That file is over 20MB, which is the most we can attach to an order. WhatsApp it to us or email info@brandmenow.co.uk and we will proof it just the same.');
      return;
    }
    if (this.picked) this.picked.hidden = false;
    if (this.fileLabel) this.fileLabel.textContent = f.name;
    if (this.filePreview) {
      if (PREVIEWABLE.test(f.name)) {
        var pr = new FileReader();
        pr.onload = function () { self.filePreview.src = pr.result; self.filePreview.hidden = false; };
        pr.readAsDataURL(f);
      } else {
        this.filePreview.hidden = true;
      }
    }
    // The File itself goes up with the cart, whatever its size. The base64 copy
    // is only for the free-mockup lead path, where there is no cart to ride on,
    // and that one still has to respect the endpoint's body limit.
    this.logoFileRaw = f;
    this.logoFile = { filename: f.name, type: f.type || '', size: f.size, content: '' };
    this._fileSay('Got it, ' + f.name + '. It is attached to your order when you add the bundle to your cart.', true);
    if (f.size <= MAX_ATTACH) {
      var r = new FileReader();
      r.onload = function () {
        var res = String(r.result || '');
        if (self.logoFile) self.logoFile.content = res.split(',')[1] || '';
      };
      r.readAsDataURL(f);
    }
  };

  // per-component allocation; returns { allComplete, total }
  Bundle.prototype._recompute = function () {
    var total = 0, allComplete = true;
    this.comps.forEach(function (comp) {
      var need = parseInt(comp.getAttribute('data-count'), 10) || 0;
      var alloc;
      if (comp.getAttribute('data-onesize')) {
        alloc = need; // one-size components are auto-allocated
      } else {
        alloc = Array.prototype.slice.call(comp.querySelectorAll('.bmn-bundle__qty'))
          .reduce(function (s, i) { return s + (parseInt(i.value, 10) || 0); }, 0);
      }
      total += Math.min(alloc, need) + Math.max(0, alloc - need); // count over-allocation too for the bar
      var allocEl = comp.querySelector('.bmn-bundle__comp-alloc');
      if (allocEl) allocEl.textContent = alloc;
      comp.classList.toggle('is-complete', alloc === need);
      comp.classList.toggle('is-over', alloc > need);
      if (alloc !== need) allComplete = false;
    });
    if (this.allocTotal) this.allocTotal.textContent = Math.min(total, this.totalItems);
    if (this.allocFill) {
      var pct = this.totalItems ? Math.min(100, Math.round(total / this.totalItems * 100)) : 0;
      this.allocFill.style.width = pct + '%';
      this.allocFill.classList.toggle('is-complete', allComplete);
    }
    if (this.addBtn) this.addBtn.disabled = !allComplete;
    return { allComplete: allComplete, total: total };
  };

  Bundle.prototype._sizeBreakdown = function (comp) {
    if (comp.getAttribute('data-onesize')) {
      return (parseInt(comp.getAttribute('data-count'), 10) || 0) + ' x One size';
    }
    var parts = [];
    Array.prototype.slice.call(comp.querySelectorAll('.bmn-bundle__size-row')).forEach(function (row) {
      var q = parseInt(row.querySelector('.bmn-bundle__qty').value, 10) || 0;
      if (q > 0) parts.push(row.getAttribute('data-size') + ' x' + q);
    });
    return parts.join(', ');
  };

  Bundle.prototype._properties = function () {
    var self = this;
    var props = { 'Bundle': this.title };
    if (this.colour) props['Kit colour'] = this.colour;
    this.comps.forEach(function (comp) {
      var name = (comp.querySelector('.bmn-bundle__comp-name') || {}).textContent || 'Item';
      props[name] = self._sizeBreakdown(comp);
    });
    if (this.kit && this.kit.decoration) props['Decoration'] = this.kit.decoration + ' (included)';
    if (this.position) props['Logo position'] = this.position;
    var companyName = this.company ? this.company.value.trim() : '';
    if (companyName) props['Company name'] = companyName;
    var mode = this._logoMode();
    var fileName = this.logoFile ? this.logoFile.filename : '';
    props['Logo'] = mode === 'upload' ? ('Attached to this order: ' + fileName) : 'To follow, free mockup first';
    props['_bundle_spec'] = JSON.stringify({ handle: this.handle, colour: this.colour, logo: mode });
    return props;
  };

  Bundle.prototype._addToCart = function () {
    var self = this;
    var state = this._recompute();
    if (!state.allComplete) { this._say('Please size every item in the kit first, each row shows how many are left.', 'error'); return; }
    var vid = this.activeVariantId || this.variantId;
    if (!vid) { this._say('This bundle is not purchasable yet. Please use the free mockup or WhatsApp.', 'error'); return; }

    var props = this._properties();
    // The live design studio (snippets/bmn-logo-preview.liquid) can hand us its design summary and a
    // mockup image. Both ride on the line item, so they land on the order next to the logo file.
    var live = window.bmnLiveForOrder ? window.bmnLiveForOrder() : null;
    if (live && live.summary) props['Design'] = live.summary;
    this.addBtn.classList.add('is-loading'); this.addBtn.disabled = true;
    Promise.resolve(live && live.mockup ? live.mockup().catch(function () { return null; }) : null)
      .then(function (blob) { self._sendToCart(vid, props, blob); });
  };

  Bundle.prototype._sendToCart = function (vid, props, mockup) {
    var self = this;
    var req;
    if (this.logoFileRaw || mockup) {
      // Shopify stores a file posted as a line-item property and puts its URL on
      // the order, so the artwork reaches us with the order itself. This only
      // works as multipart, never as JSON.
      var fd = new FormData();
      fd.append('id', vid);
      fd.append('quantity', '1');
      Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
      if (this.logoFileRaw) fd.append('properties[Logo file]', this.logoFileRaw);
      if (mockup) fd.append('properties[Design mockup]', mockup, 'design-mockup.jpg');
      req = fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      this._say(this.logoFileRaw ? 'Uploading your logo and adding the bundle to your cart...' : 'Saving your design and adding the bundle to your cart...', 'success');
    } else {
      var body = { items: [{ id: vid, quantity: 1, properties: props }] };
      req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    }
    req
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }, function () { return { ok: false, d: { description: r.status === 413 ? 'That logo file is too big to attach to an order. Please WhatsApp it to us instead.' : 'Could not add the bundle to your cart.' } }; }); })
      .then(function (res) {
        if (!res.ok) { self._say((res.d && (res.d.description || res.d.message)) || 'Could not add the bundle to your cart.', 'error'); return; }
        self._refreshCart();
        self._sayAdded();
      })
      .catch(function () { self._say('Something went wrong. Please try again or use WhatsApp.', 'error'); })
      .finally(function () { self.addBtn.classList.remove('is-loading'); self.addBtn.disabled = !self._recompute().allComplete; });
  };

  Bundle.prototype._refreshCart = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-count-bubble').forEach(function (b) { b.hidden = c.item_count === 0; var v = b.querySelector('[aria-hidden="true"]'); if (v) v.textContent = c.item_count; });
      if (typeof window.publish === 'function') { try { window.publish('cart:refresh', { source: 'bmn-bundle' }); } catch (e) {} }
    }).catch(function () {});
  };

  Bundle.prototype._quoteMessage = function () {
    var self = this;
    var lines = ['Bundle enquiry from the website.', 'Bundle: ' + this.title + ' (' + this.handle + ')'];
    if (this.colour) lines.push('Kit colour: ' + this.colour);
    this.comps.forEach(function (comp) {
      var name = (comp.querySelector('.bmn-bundle__comp-name') || {}).textContent || 'Item';
      var need = comp.getAttribute('data-count') || '';
      var bd = self._sizeBreakdown(comp);
      lines.push(name + ' (' + need + '): ' + (bd || 'sizes not chosen yet, please advise'));
    });
    if (this.position) lines.push('Logo position: ' + this.position);
    if (this.company && this.company.value.trim()) lines.push('Company name: ' + this.company.value.trim());
    lines.push('Logo: ' + (this._logoMode() === 'upload'
      ? (this.logoFile.filename + ' (attached to the order, or please attach it to this message)')
      : 'to follow, free mockup first'));
    lines.push('Please send a free mockup and confirm the bundle.');
    return lines.join('\n');
  };

  Bundle.prototype._whatsapp = function () {
    var num = this.whatsapp.replace(/[^0-9]/g, '');
    if (!num) { window.location.href = 'mailto:info@brandmenow.co.uk?subject=' + encodeURIComponent('Bundle enquiry: ' + this.title) + '&body=' + encodeURIComponent(this._quoteMessage()); return; }
    window.open('https://wa.me/' + num + '?text=' + encodeURIComponent(this._quoteMessage()), '_blank');
  };

  Bundle.prototype._openLead = function (reason) {
    if (!this.lead) { this._whatsapp(); return; }
    var h = this.lead.querySelector('.bmn-bundle__lead-head');
    if (h) h.textContent = 'See it with my logo, free mockup';
    this.lead.hidden = false;
    var f = this.lead.querySelector('[name="email"]'); if (f) setTimeout(function () { f.focus(); }, 50);
  };

  Bundle.prototype._submitLead = function () {
    var self = this;
    var name = (this.lead.querySelector('[name="name"]') || {}).value || '';
    var email = (this.lead.querySelector('[name="email"]') || {}).value || '';
    if (!name.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim())) { this._leadSay('Please add your name and a valid email.'); return; }
    if (!this.leadUrl) { this._leadSay('Please use WhatsApp, or email info@brandmenow.co.uk.'); return; }
    var btn = this.lead.querySelector('.bmn-bundle__lead-submit'); if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
    var parts = name.trim().split(/\s+/);
    var isHs = /hsforms\.com/i.test(this.leadUrl);
    var payload = isHs
      ? { fields: [ { name: 'email', value: email.trim() }, { name: 'firstname', value: parts.shift() || name }, { name: 'lastname', value: parts.join(' ') }, { name: 'message', value: this._quoteMessage() } ], context: { pageUri: location.href, pageName: document.title } }
      : { name: name, email: email, message: this._quoteMessage() };
    if (this.quoteEndpoint && this.logoFile) {
      try {
        fetch(this.quoteEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: name.trim(),
            email: email.trim(),
            phone: '',
            source: 'bundle:' + this.handle,
            message: this._quoteMessage(),
            logo: this.logoFile,
            attachments: [{ filename: this.logoFile.filename, content: this.logoFile.content }]
          })
        }).catch(function () {});
      } catch (e) {}
    }
    fetch(this.leadUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.ok; })
      .then(function (ok) {
        if (ok) {
          var extra = (self._logoMode() === 'upload' && !self.attachmentsLive)
            ? ' Please send your logo file over on WhatsApp or to info@brandmenow.co.uk so we can proof it.'
            : '';
          self.lead.querySelector('.bmn-bundle__lead-card').innerHTML = '<div class="bmn-bundle__lead-done">Thanks ' + esc(name.split(/\s+/)[0]) + ', your request is on its way. We will send your free mockup and confirm the bundle, usually within one working day.' + extra + '</div>';
        }
        else self._leadSay('That did not send. Please use WhatsApp or email info@brandmenow.co.uk.');
      })
      .catch(function () { self._leadSay('That did not send. Please use WhatsApp or email info@brandmenow.co.uk.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = 'Send my request'; } });
  };
  Bundle.prototype._leadSay = function (t) { var m = this.lead.querySelector('.bmn-bundle__lead-msg'); if (m) m.textContent = t; };

  // Once the add succeeds the sale is made. Never put a form in front of it:
  // confirm inline, lead with checkout, and offer the logo step as a choice.
  Bundle.prototype._sayAdded = function () {
    if (!this.msg) return;
    var self = this;
    this.msg.className = 'bmn-bundle__msg bmn-bundle__msg--success';
    this.msg.innerHTML =
      '<strong class="bmn-bundle__added-head">Bundle added to your cart.</strong>' +
      '<span class="bmn-bundle__added-sub">' + (this.logoFileRaw
        ? 'Your logo is attached to the order, nothing else to send. We will email your free mockup before anything is made.'
        : 'No logo needed to order. We will ask for it after checkout and send a free mockup before anything is made.') + '</span>' +
      '<span class="bmn-bundle__added-acts">' +
        '<a class="bmn-bundle__added-go" href="/checkout">Checkout</a>' +
        '<a class="bmn-bundle__added-cart" href="/cart">View cart</a>' +
        '<button type="button" class="bmn-bundle__added-logo">Send my logo now</button>' +
      '</span>';
    this.msg.hidden = false;
    var b = this.msg.querySelector('.bmn-bundle__added-logo');
    if (b) b.addEventListener('click', function () { self._openLead('mockup'); });
    try { this.msg.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  };
  Bundle.prototype._say = function (t, type) { if (!this.msg) return; this.msg.textContent = t; this.msg.className = 'bmn-bundle__msg bmn-bundle__msg--' + type; this.msg.hidden = false; };
  Bundle.prototype._clearMsg = function () { if (this.msg) { this.msg.hidden = true; this.msg.textContent = ''; } };

  function init() {
    document.querySelectorAll('.bmn-bundle').forEach(function (el) {
      if (el.dataset.bundleInit) return; el.dataset.bundleInit = '1';
      if (!el.querySelector('.bmn-bundle__kit')) return; // not configured
      try { el.__bundle = new Bundle(el); } catch (e) { console.warn('[BMN bundle]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
